/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as AccessDefs from "./defs.defs.js";

const $nsid = "place.stream.access.grant";

export { $nsid };

/** Grants one role to one account on a node. Lives in the node's access-control space (space type place.stream.access.control, skey self, authority = the broadcaster DID) and is authored by the admin who created it; until the atproto spaces implementation ships, the node stores it in statedb addressed by its at:// space URI. */
type Main = { $type: "place.stream.access.grant";

  /**
   * The account receiving the role.
   */
  "subject":l.DidString;"role":AccessDefs.Role;"createdAt":l.DatetimeString;

  /**
   * Free-form reminder of why the grant exists.
   */
  "note"?:string };

export type { Main };

/** Grants one role to one account on a node. Lives in the node's access-control space (space type place.stream.access.control, skey self, authority = the broadcaster DID) and is authored by the admin who created it; until the atproto spaces implementation ships, the node stores it in statedb addressed by its at:// space URI. */
const main = /*#__PURE__*/ l.record<"tid", Main>("tid", $nsid, /*#__PURE__*/ l.object({"subject":/*#__PURE__*/ l.string({"format":"did"}),"role":/*#__PURE__*/ l.ref<AccessDefs.Role>((() => AccessDefs.role) as any),"createdAt":/*#__PURE__*/ l.string({"format":"datetime"}),"note":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"maxLength":1000,"maxGraphemes":100}))}));

export { main };

export const $type = $nsid;
export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main);
export const $build = /*#__PURE__*/ main.build.bind(main);
export const $assert = /*#__PURE__*/ main.assert.bind(main);
export const $check = /*#__PURE__*/ main.check.bind(main);
export const $cast = /*#__PURE__*/ main.cast.bind(main);
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main);
export const $matches = /*#__PURE__*/ main.matches.bind(main);
export const $parse = /*#__PURE__*/ main.parse.bind(main);
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main);
export const $validate = /*#__PURE__*/ main.validate.bind(main);
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main);
